import React, { useState } from "react";
import { Table } from "antd";
import isEmpty from "lodash/isEmpty";

const Datatable = ({
  props,
  columns,
  pagination,
  decimalpoints,
  dataSource,
  footerTotals,
  branches = [],
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
 
  // console.log(dataSource,"datasoooource")
// console.log(footerTotals,"itemmmmmmmmmmmmmmmm");
// console.log(footer,"foooooooot");
console.log(footerTotals,"tooooooooootal");

  return (
    <Table
      key={props}
      className=""
      columns={columns}
      // footerTotals={footerTotals}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      // pagination={{
      //   showTotal: (total, range) =>
      //     `${range[0]}-${range[1]} of ${total} items`,
      // }}
      pagination={{
        ...pagination,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      }}
      summary={() => {
        return (
          <Table.Summary>
            {!isEmpty(footerTotals) && (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={1}>
                  <strong>Total</strong>
                </Table.Summary.Cell>
                {branches.map((branch, index) => {
                  const netQuantity = footerTotals.netQuantity[branch] || 0;
                  const netTotal = footerTotals.netTotal[branch] || 0;

                  return netQuantity > 0 || netTotal > 0 ? ( // Only render if either value is greater than 0
                    <React.Fragment key={branch}>
                      <Table.Summary.Cell
                        key={`${branch}_quantity`}
                        index={index * 2 + 1}
                      >
                        {netQuantity.toFixed(2)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        key={`${branch}_total`}
                        index={index * 2 + 2}
                      >
                        {netTotal.toFixed(2)}
                      </Table.Summary.Cell>
                    </React.Fragment>
                  ) : null; // Do not render anything if both values are 0
                })}
                <Table.Summary.Cell index={branches.length * 2 + 1} colSpan={1}>
                  {footerTotals.itemQuantity !== undefined
                    ? footerTotals.itemQuantity.toFixed(decimalpoints)
                    : "0.00"}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={branches.length * 2 + 2} colSpan={1}>
                  {footerTotals.itemTotal !== undefined
                    ? footerTotals.itemTotal.toFixed(decimalpoints)
                    : "0.00"}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          </Table.Summary>
        );
      }}
//       summary={() => (
//         <Table.Summary.Row>
//           <Table.Summary.Cell index={0}><strong>Total</strong></Table.Summary.Cell>
//           <Table.Summary.Cell index={1}>{footerTotals?.netQuantity || "0.00"}</Table.Summary.Cell>
//           {/* <Table.Summary.Cell index={2}>
//   {typeof footerTotals?.netTotal === "number"
//     ? footerTotals.netTotal.toFixed(2)
//     : "0.00"}
// </Table.Summary.Cell> */}
//           <Table.Summary.Cell index={2}>{footerTotals?.paymentTotals?.Amex?.toFixed(2) || "0.00"}</Table.Summary.Cell>
//           <Table.Summary.Cell index={3}>{footerTotals?.paymentTotals?.Card?.toFixed(2) || "0.00"}</Table.Summary.Cell>
//           <Table.Summary.Cell index={4}>{footerTotals?.paymentTotals?.FedNet?.toFixed(2) || "0.00"}</Table.Summary.Cell>
//           <Table.Summary.Cell index={5}>{footerTotals?.paymentTotals?.Gpay?.toFixed(2) || "0.00"}</Table.Summary.Cell>
//         </Table.Summary.Row>
//       )}
      
    />
  );
};

export default Datatable;
